/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContemporaryLandingCategoriesModule_contemporaryLandingRow$ref: FragmentReference;
export type ContemporaryLandingCategoriesModule_contemporaryLandingRow = {|
  +items: ?$ReadOnlyArray<?{|
    +text?: ?string,
    +type?: ?string,
    +items?: ?$ReadOnlyArray<?{|
      +browseUrl?: ?string,
      +items?: ?$ReadOnlyArray<?{|
        +browseUrl: ?string,
        +key: ?string,
        +name: ?string,
        +imagePath: ?string,
      |}>,
      +key?: ?string,
      +name?: ?string,
    |}>,
  |}>,
  +$refType: ContemporaryLandingCategoriesModule_contemporaryLandingRow$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "browseUrl",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ContemporaryLandingCategoriesModule_contemporaryLandingRow",
  "type": "ContemporaryLandingRow",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "ContemporaryLandingRow",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "type": "ContemporaryLandingCategoryL2",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "items",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ContemporaryLandingCategoryL3",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        (v2/*: any*/),
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "imagePath",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    },
                    (v1/*: any*/),
                    (v2/*: any*/)
                  ]
                }
              ]
            },
            (v3/*: any*/)
          ]
        },
        {
          "kind": "InlineFragment",
          "type": "ContemporaryLandingHeader",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "text",
              "args": null,
              "storageKey": null
            },
            (v3/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '4776d688aa800275ce93ebd9ccc0db84';
module.exports = node;
